import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Cover from '../../components/Cover/Cover';
import ListSection from '../../components/ListSections/ListSections/ListSections.view';
import ListProduct from '../../components/ListProduct';
import Footer from '../../components/Footer';
import Splash from '../../components/Splash';
import InfoBar from '../../components/InfoBar/InfoBar.view';
import {
  setIsMobile,
  showAddressModal,
  showHorizontalSection,
  showMessageModal,
  updateShopIsLoaded,
} from '../../redux/actions';
import {
  getClosedMessage,
  isQrCode,
  isSplash,
  isStringNotNull,
} from '../../utils';
import { loadLocalizeSdk } from '../../api';
import {
  displayOrNotHeader,
  getClasses,
  handleScroll,
  updateDimensions,
  verifyPendingOrderValidity,
} from './Home.services';
import {
  BLOCK_CONTENT,
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_DELIVERY,
} from '../../constants';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import CloseBar from './components/CloseBar';
import ThresholdMarketingProgress from '../../components/ThresholdMarkertingProgress/ThresholdMarketingProgress.view';
import { UPDATE_PENDING_ORDER } from '../../redux/actions/types';
import { getCookieConsentValue } from 'react-cookie-consent';
import AddressModal from '../../components/AddressModal';

export default function Home() {
  const dispatch = useAppDispatch();

  const { shopId: shopIdFromLink } = useParams();

  if (shopIdFromLink === 'mentions-legales') {
    return <></>;
  }

  const { shops } = useAppSelector((state) => state.shopReducer);
  const [displaySectionsNavBar, setDisplaySectionsNavBar] = useState(false);
  const [hasDisplayedOrderTypeDelivery, setHasDisplayedOrderTypeDelivery] =
    useState(false);
  const [executed, setExecuted] = useState(false);
  const {
    address: customerAddress,
    addressIsLoaded,
    shopId,
    isInit,
    orderType,
  } = useAppSelector((state) => state.pendingOrderReducer);

  useEffect(() => {
    const handleConfigFromLink = async () => {
      if (shopId === null) {
        dispatch({
          type: UPDATE_PENDING_ORDER,
          payload: {
            address: null,
            shopId: shopIdFromLink,
            orderType: ORDER_TYPE_DELIVERY,
          },
        });
        dispatch(showAddressModal(true));
      } else if (shopId !== shopIdFromLink) {
        dispatch({
          type: UPDATE_PENDING_ORDER,
          payload: {
            address: null,
            shopId: shopIdFromLink,
            orderType: ORDER_TYPE_CLICK_AND_COLLECT,
          },
        });
        dispatch(showAddressModal(true));
      }
    };

    if (isInit && isStringNotNull(shopIdFromLink)) handleConfigFromLink();
  }, [shopIdFromLink, isInit]);

  useEffect(() => {
    if (hasDisplayedOrderTypeDelivery) {
      return;
    }
    if (orderType === ORDER_TYPE_DELIVERY && customerAddress) {
      setHasDisplayedOrderTypeDelivery(true);
      return;
    }
    const shop = shops?.[shopId];
    if (!shop) {
      return;
    }
    const shopOrderTypes = shop?.configuration?.orderTypes ?? [];
    if (!shopOrderTypes.includes(ORDER_TYPE_DELIVERY)) {
      setHasDisplayedOrderTypeDelivery(true);
      return;
    }
    setHasDisplayedOrderTypeDelivery(true);
    if (!isQrCode() && !isStringNotNull(shopIdFromLink)) {
      dispatch(showAddressModal(true));
    }
  }, [orderType, shopId, shops]);

  const { thresholdOffer } = useAppSelector((state) => state.offerReducer);

  const {
    navbarHeight,
    overlayCover,
    isHorizontalSection,
    googleMapsEnabled,
    connexionModal,
    customerAddressCheck,
  } = useAppSelector((state) => state.componentReducer);
  const { sectionOrientation } = useAppSelector(
    (state) => state.configurationReducer,
  );
  const { closed, shopIsLoaded } = useAppSelector((state) => state.shopReducer);

  const listSectionsRef = useRef(null);
  const { listSectionClass, listProductClass } = getClasses();
  const displayNavBar =
    isHorizontalSection && (displaySectionsNavBar || isQrCode());
  displayOrNotHeader(displaySectionsNavBar || isQrCode());
  const displayOverlay = overlayCover === BLOCK_CONTENT;
  const showSplash = isSplash() && !shopIsLoaded;

  useEffect(() => {
    const dimensionUpdate = () => updateDimensions();
    const scrollEvent = () =>
      handleScroll(
        listSectionsRef.current,
        displaySectionsNavBar,
        setDisplaySectionsNavBar,
      );

    loadLocalizeSdk();
    dispatch(
      setIsMobile(window.matchMedia('screen and (max-width: 575px)').matches),
    );
    window.addEventListener('scroll', scrollEvent);
    window.addEventListener('resize', dimensionUpdate);
    dispatch(showHorizontalSection());

    return () => {
      window.removeEventListener('scroll', scrollEvent);
      window.removeEventListener('resize', dimensionUpdate);
    };
  }, [listSectionsRef.current, displaySectionsNavBar]);

  useEffect(() => {
    dispatch(showHorizontalSection());
  }, [sectionOrientation]);

  useEffect(() => {
    if (
      overlayCover !== BLOCK_CONTENT &&
      !customerAddress &&
      googleMapsEnabled &&
      addressIsLoaded &&
      !isQrCode() &&
      !executed &&
      !isSplash() &&
      !connexionModal
    ) {
      setExecuted(true);
      setExecuted(true);
      dispatch(showAddressModal(true));
    }
  }, [
    overlayCover,
    customerAddress,
    googleMapsEnabled,
    addressIsLoaded,
    executed,
    connexionModal,
    addressIsLoaded,
    customerAddressCheck,
  ]);

  useEffect(() => {
    if (!customerAddress && addressIsLoaded && !shopIsLoaded) {
      dispatch(updateShopIsLoaded(true));
    }
  }, [customerAddress, addressIsLoaded, shopIsLoaded]);

  useEffect(() => {
    if (shopIsLoaded && customerAddress && isStringNotNull(closed)) {
      dispatch(showMessageModal(getClosedMessage(closed)));
    }
  }, [shopIsLoaded, customerAddress, closed]);

  useEffect(() => {
    (async () => {
      await verifyPendingOrderValidity();
    })();
  }, []);

  const onTouchStart = () => {
    document.body.style.overflow = 'hidden';
  };

  const onTouchEnd = () => {
    document.body.style.overflow = 'visible';
  };

  return showSplash ? (
    <Splash />
  ) : (
    <>
      {!displayOverlay && (
        <div>
          <div
            id='top'
            style={{ position: 'absolute', top: '0px', left: '0px' }}
          />
          {!isQrCode() && <Cover />}
          <div
            className='container-fluid px-0'
            id='main-container'
          >
            {isHorizontalSection ? (
              <div ref={listSectionsRef}>
                <div
                  id='info-bar'
                  className={`shadow ${displayNavBar ? 'fixed-top' : ''}`}
                  onTouchStart={onTouchStart}
                  onTouchEnd={onTouchEnd}
                >
                  {shopIsLoaded && <CloseBar />}
                  <InfoBar />
                  <ListSection />
                </div>
              </div>
            ) : (
              <div ref={listSectionsRef}>
                <div
                  id='info-bar'
                  className={`shadow ${
                    displaySectionsNavBar || isQrCode() ? 'fixed-top' : ''
                  }`}
                >
                  {shopIsLoaded && <CloseBar />}
                  <InfoBar />
                </div>
              </div>
            )}
            <div className={`col-12 px-0 px-sm-5 `}>
              <div className={`row px-3 px-sm-0 px-md-3`}>
                {!isHorizontalSection && (
                  <div
                    className={listSectionClass}
                    style={{
                      marginTop:
                        displaySectionsNavBar || isQrCode()
                          ? navbarHeight
                          : '16px',
                    }}
                  >
                    <ListSection />
                  </div>
                )}
                <div
                  className={listProductClass}
                  style={{
                    marginTop:
                      displaySectionsNavBar || isQrCode()
                        ? navbarHeight
                        : '16px',
                  }}
                >
                  <ListProduct />
                </div>
              </div>
            </div>
          </div>
          <Footer />
          {thresholdOffer && (
            <ThresholdMarketingProgress offer={thresholdOffer} />
          )}
          {getCookieConsentValue() === 'true' ? <AddressModal /> : null}
        </div>
      )}
    </>
  );
}
